import { useShiftBoardData } from "./useShiftBoardData";

export function useGetShiftBoardWorkplace({ token }: { token: string }) {
  const { workplace } = useShiftBoardData({ token });
  return workplace;
}
